import React from 'react';
import { injectIntl } from 'react-intl';
import { useResendEmailData } from '../../../../hook';
import { CheckEmailPagePropsType } from '../../../../model/check-email-page';
import { getCheckEmailAnalyticsService } from '../../../../service/check-email-page';
import { LayoutDefault, LayoutDevops } from './container';

// UA ID detected on current checkemail page
const googleAnalyticsId = 'UA-6032469-23';

export const CheckEmailPage: React.FC<CheckEmailPagePropsType> = ({
  layout,
  baseUrl,
  analyticsTrack,
  productKeys,
  hideHeader
}) => {
  const [{ email = '', shouldEnable }, {}] = useResendEmailData();
  const props = Object.assign(
    {},
    {
      baseUrl,
      email,
      shouldEnable,
      hideHeader
    }
  );

  const checkEmailAnalyticsService = getCheckEmailAnalyticsService({
    analyticsTrack,
    baseUrl,
    productKeys,
    googleAnalyticsId
  });

  return (() => {
    switch (layout) {
      case 'devops':
        return (
          <LayoutDevops
            {...props}
            checkEmailAnalyticsService={checkEmailAnalyticsService}
          />
        );
      case 'default':
      default:
        return (
          <LayoutDefault
            {...props}
            checkEmailAnalyticsService={checkEmailAnalyticsService}
          />
        );
    }
  })();
};

export default injectIntl(CheckEmailPage);
